import { useEffect, useState } from 'react';
import './TextLabelModal.css';

const DEFAULT_TEXT_COLOR = '#000000';

// trigger by a click of the text tool
// used to enter the label and its color before saving
function TextLabelModal({ open, initialColor = DEFAULT_TEXT_COLOR, onClose, onSubmit }) {
  const [value, setValue] = useState('');
  const [color, setColor] = useState(initialColor);

  useEffect(() => {
    if (!open) return;
    setValue('');
    setColor(initialColor || DEFAULT_TEXT_COLOR);
  }, [open, initialColor]);

  if (!open) return null;

  const handleSubmit = (e) => {
    e?.preventDefault?.();
    const trimmed = value.trim();
    if (!trimmed) return;
    onSubmit?.({ value: trimmed, color: color || DEFAULT_TEXT_COLOR });
  };

  return (
    <div className="map-label-modal-backdrop" onClick={onClose}>
      <form className="map-label-modal" onSubmit={handleSubmit} onClick={(e) => e.stopPropagation()}>
        <textarea
          autoFocus
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Libellé"
          rows={3}
        />
        <input
          type="color"
          value={color}
          onChange={(e) => setColor(e.target.value)}
          aria-label="Color"
        />
        <div className="map-label-modal-actions">
          <button type="button" onClick={onClose}>Annuler</button>
          <button type="submit">OK</button>
        </div>
      </form>
    </div>
  );
}

export default TextLabelModal;
